import MarkdownIt from "markdown-it";
import hljs from "highlight.js";
import mk from 'markdown-it-katex';
import 'katex/dist/katex.min.css';

// 创建 markdown-it 实例
const md = new MarkdownIt({
  html: true,
  linkify: true,
  breaks: true,
  typographer: true,
  highlight: function (str, lang) {
    if (lang && hljs.getLanguage(lang)) {
      try {
        return hljs.highlight(lang, str).value;
      } catch (__) {
        console.log("error", str, lang);
      }
    }
    return "";
  }
}).use(mk);

// 处理 Markdown 文本的函数
export const renderMarkdown = (text) => {
  if (!text) return '';
  try {
    // 预处理LaTeX公式
    let processedText = text.replace(/\\\[/g, '$$').replace(/\\\]/g, '$$')
                           .replace(/\\\(/g, '$').replace(/\\\)/g, '$');
    return md.render(processedText);
  } catch (error) {
    console.error("Markdown rendering error:", error);
    return text;
  }
};

// 导出 markdown-it 实例，以便需要时可以直接使用
export const markdownInstance = md; 